export default "__VITE_ASSET__BRIh1Mtu__"